// Converte o carrinho do cardápio pro formato que o backend valida.
// Manda `id` sempre: é com ele que o backend reconfere preço, disponibilidade
// e categoria escondida de cada item e de cada complemento.
//
// As escolhas das etapas (batata, bebida do combo…) vêm do popup como
// `step_selections` e viram `subitems`/`etapas` pela mesma regra do checkout do
// cardápio (utils/etapasDoItem.js). Antes daqui iam vazias e o KDS mostrava o
// combo sem as escolhas (Mestre dos Jogos, 26/09/2026). `produtos` = a lista de
// produtos do cardápio (preço atual dos adicionais).
import { resumoEtapasDoItem, subitemsDoItem } from "../../utils/etapasDoItem";

export function itensParaRodada(cart, produtos = []) {
  return (cart || []).map((item) => ({
    id: item.id,
    product_id: item.id,
    nome: item.name,
    quantidade: Number(item.quantity || 1),
    preco: Number(item.final_price ?? item.sale_price ?? 0),
    observacao: item.observation || null,
    photo_url: item.photo_url || null,
    subitems: subitemsDoItem(item, produtos),
    etapas: resumoEtapasDoItem(item),
    combo_type: item.combo_type || null,
    is_promotional: !!item.is_promotional,
    pizza_meta: item.pizza || item.pizza_meta || null,
  }));
}

export function totalDoCarrinho(cart) {
  return (cart || []).reduce(
    (soma, i) => soma + Number(i.final_price ?? i.sale_price ?? 0) * Number(i.quantity || 1), 0);
}
